<style>
@import '../../custom/css/lista-dicas.css';

#profissionais .limit-table::-webkit-scrollbar:vertical {
  display: none;
}
</style>

<template>
  <div id="profissionais">
    <h1 class="title text-uppercase font-weight-bold">
      Lista de Profissionais Gratuito
    </h1>
    <hr class="linha-amarela" />
    <div class="limit-table">
      <table class="table w-1200px">
        <thead class="letter-orange">
          <tr>
            <th></th>
            <th>Nome ou Nome Fantasia</th>
            <th>CPF ou CNPJ</th>
            <th>E-mail</th>
            <th>Criado em.</th>
            <th>Atualizado em.</th>
            <th v-if="hasWritePermission()">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(profissional, index) in profissionais" :key="index">
            <td class="font-weight-bold fs-24">{{ index + 1 }}</td>
            <td v-if="profissional.nome !== null">{{ profissional.nome }}</td>
            <td v-else-if="profissional.nome_fantasia !== null">
              {{ profissional.nome_fantasia }}
            </td>
            <td v-else>Sem Nome ou Nome Fantasia</td>
            <td v-if="profissional.cpf !== null">{{ profissional.cpf }}</td>
            <td v-else-if="profissional.cnpj !== null">
              {{ profissional.cnpj }}
            </td>
            <td v-else>Sem CPF ou CNPJ</td>
            <td>{{ profissional.usuario }}</td>
            <td>{{ profissional.criado_em }}</td>
            <td>{{ profissional.atualizado_em }}</td>
            <td v-if="hasWritePermission()">
              <div
                class="btn btn-primary mr-1"
                @click="editarProfissional(profissional.id)"
              >
                <i class="fas fa-edit"></i>
              </div>
              <div
                class="btn btn-warning mr-1"
                @click="verProfissional(profissional.id)"
              >
                <i class="fas fa-eye"></i>
              </div>
              <div
                class="btn btn-danger"
                @click="excluirProfissional(profissional.usuario_id)"
              >
                <i class="fas fa-trash-alt"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'profissionais',
  computed: {
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getLoaderAction',
    ]),
    ...mapState({
      profissionais: (state) => state.profissionais,
    }),
    ...mapState(['token', 'dadosUsuario']),
  },
  created() {
    this.$store.dispatch('showProfissionaisGeral');
  },
  methods: {
    editarProfissional(value) {
      this.$router.push({
        name: 'administrador-editar-profissional',
        params: { id: value },
      });
    },
    verProfissional(value) {
      this.$router.push({
        name: 'administrador-ver-profissional',
        params: { id: value },
      });
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    async excluirProfissional(id) {
      const self = this;
      if (window.confirm('Deseja deletar realmente esse profissional?')) {
        self.$store.dispatch('startLoader');
        await this.$store
          .dispatch('deleteUsuario', id)
          .then(() => {
            self.aviso('Deletado com sucesso', 'success');
            setTimeout(() => {
              self.$store.dispatch('showProfissionaisPendentes').then(() => {
                setTimeout(() => {
                  self.$store.dispatch('endLoader');
                }, 100);
              });
            }, 1000);
          })
          .catch(() => {
            self.$store.dispatch('endLoader');
            self.aviso(
              'Houve um problema para deletar, tente novamente em 5 minutos!',
              'danger'
            );
          });
      }
    },
    hasWritePermission() {
      return this.dadosUsuario.permitido_escrita == 1;
    },
  },
};
</script>
